import React from 'react'
import { cn } from '@utils/safeTs'
import styles from './MyAccountOrdineDetailBox.module.sass'


interface Props {
  title?: string
  actions?: React.ReactNode
  children?: React.ReactNode
  className?: string
  headerClassName?: string
  bodyClassName?: string
}

const MyAccountOrdineDetailBox = (props: Props) => {

  const { 
    title,
    actions,
    children,
    className,
    headerClassName,
    bodyClassName,
  } = props

  return (
    <section className={cn(styles.root, className)} aria-label={title}>
      <header className={cn(styles.header, headerClassName)}>
        <h2 className={styles.title}>{title}</h2>
        {actions}
      </header>
      <div className={cn(styles.body, bodyClassName)}>
        {children}
      </div>
    </section>
  )
}

export default MyAccountOrdineDetailBox
